<template>
  <b-card class="bg-white rounded-xl p-4 px-2 py-2">
    <div class="flex items-center pb-4">
      <div
        class="mr-2 flex gap-1 cursor-pointer"
        @click="handleClick('admin-brochure')"
      >
        <ChevronLeftIcon />
        <h2 class="text-2xl font-medium text-3d3d3d">Back</h2>
      </div>
    </div>

    <el-form role="form">
      <el-input
        type="text"
        v-model="title"
        class=""
        placeholder="Title"
        @input="() => (nameErr = false)"
      />
      <span v-if="nameErr" class="small text-danger">{{ msg.name }}</span>

      <div class="mb-8 pt-4">
        <div
          class="text-sm text-gray-600 font-medium px-2 py-1 mb-1 border rounded bg-gray-100 inline-block"
        >
          Recommended Size: 400 × 400px
        </div>
        <FileUploader
          v-show="!image"
          :image="image"
          :onSuccess="handleSuccess"
          :accept="'application/pdf, .pdf'"
        />
      </div>
      <iframe :src="image" v-if="image" frameborder="0"></iframe>
      <span v-if="imageErr" class="small text-danger">{{ msg.image }}</span>
      <div class="flex cursor-pointer items-center my-2" v-if="image">
        <button type="danger" class="px-8" @click="reset">Remove image</button>
      </div>
      <div>
        <div class="text-center py-4">
          <b-button
            class="bg-primary px-10 py-2 rounded text-white text-l"
            type="submit"
            variant="secondary"
            @click.prevent="onSubmit"
          >
            Save
          </b-button>
        </div>
      </div>
    </el-form>
  </b-card>
</template>

<script>
// import { VueEditor } from "vue2-editor";

import _ from "lodash";
import { ChevronLeftIcon } from "vue-feather-icons";
import { mapState } from "vuex";
import FileUploader from "@/components/FileUploader";
export default {
  components: {
    ChevronLeftIcon,
    FileUploader,
  },
  data() {
    return {
      title: "",
      image: null,
      coverImage: null,

      file: null,
      editorOption: {
        theme: "snow",
      },
      imageErr: false,
      nameErr: false,
      msg: {},
    };
  },
  methods: {
    async reset() {
      this.title = "";
      this.image = null;
    },
    handleSuccess(image) {
      this.imageErr = false;
      if (!image.type.includes("application")) {
        this.imageErr = true;
        this.msg.image = "Upload PDF File Only";
      } else {
        this.imageErr = false;

        this.coverImage = image;
        this.readerData(image);
      }
    },
    readerData(rawFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));
      };
      reader.readAsDataURL(rawFile);
    },
    async onSubmit() {
      this.nameErr = this.imageErr = false;
      let FormData = require("form-data");

      if (this.title.trim() == "") {
        this.nameErr = true;
        this.msg.name = "Title is required";
        return;
      }

      if (!this.coverImage) {
        this.imageErr = true;
        this.msg.image = "Please select an image";
        return;
      }
      let payload = new FormData();
      payload.append("title", this.title);
      payload.append("file", this.coverImage);
      try {
        let loader = this.$loading();

        let data = await this.$store.dispatch("coach/CreateBrochure", payload);
        this.$router.push({ name: "admin-brochure" });
        if (data.code == 200) {
          this.$swal.fire({
            text: "Your brochure has been uploaded!",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          this.reset();
        }

        loader.close();
      } catch (err) {
        loader.close();
      }
    },

    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
  computed: {
    ...mapState("coach", {
      borach: "borach",
    }),
  },
  async created() {
    try {
      await this.$store.dispatch("coach/GetBrochure");
    } catch (err) {
      console.log(err);
    }
  },
};
</script>
